/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clinicautocomplete_Searching1Inputs */

const en_clinicautocomplete_searching1 = /** @type {(inputs: Clinicautocomplete_Searching1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching clinics...`)
};

const fr_clinicautocomplete_searching1 = /** @type {(inputs: Clinicautocomplete_Searching1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche de cliniques...`)
};

/**
* | output |
* | --- |
* | "Searching clinics..." |
*
* @param {Clinicautocomplete_Searching1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const clinicautocomplete_searching1 = /** @type {((inputs?: Clinicautocomplete_Searching1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clinicautocomplete_Searching1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clinicautocomplete_searching1(inputs)
	return fr_clinicautocomplete_searching1(inputs)
});
export { clinicautocomplete_searching1 as "clinicAutocomplete_searching" }